export class VedraxFileError {
    name: string = '';
    errorMessage: string = '';
}